import { AnyAction } from "redux";
import { ThunkAction, ThunkDispatch } from "redux-thunk";
import { gcAirportCitySEOScreen, gcCitySEOScreen, gcRouteSEOScreen, pageViewOmniEvent } from "./omni";
import { timeDiff } from "./utils";

export const pageView = (
  screenName = "goCarsHomeScreen"
): ThunkAction<void, AppState, {}, AnyAction> => {
  return async (
    dispatch: ThunkDispatch<AppState, {}, AnyAction>,
    getState: () => AppState
  ) => {
    const store = getState();
    const { common = {}, review = {}, srp = {}, seoPage = {} } = store;
    const { tripType = {}, flow = "direct-cabs" } = common;
    const { results = {}, filters = {} } = srp;
    const { common_data = {}, vehicle_data = [] } = results;
    const {
      dispatch_search_id = "",
      source_city = "",
      destination_city = "",
      search_tags = [],
      start_time = "",
      end_time = "",
    } = common_data;
    const { reviewResults = {} } = review;
    const { booking_tags = [], other_tags = [], key = "", sku_event_key = "" } = reviewResults;
    const { name = "" } = tripType;
    const { seo_meta = {} } = seoPage;
    let commonData = {
      funnel_version: "intercity-react",
      flow: flow || 'direct-cabs',
      screenName,
      cdCatQuery: "",
      cdSubCatQuery: name.toLowerCase(),
      trip_type: name.toLowerCase(),
      event: "virtualPageView",
    };
    let data = {};
    let return_offset = "";
    if (start_time && end_time) {
      return_offset = timeDiff(new Date(start_time), new Date(end_time));
    }

    switch (screenName) {
      case "goCarsHomeScreen":
        data = { ...commonData, virtualpage: "/cars/" };
        pageViewOmniEvent(store)
        break;
      case "goCarsTripCategoryScreen":
        const tripScreen = {
          cdCatQuery: "cabs",
          is_private_available: vehicle_data?.length ? "yes" : "no",
          applied_filters: JSON.stringify(filters),
          results_count: vehicle_data?.length,
          searchid: dispatch_search_id,
          source_city,
          destination_city,
          sector: `${source_city} - ${destination_city}`,
          search_tags: search_tags?.join(","),
          return_offset: "",
          virtualpage: "/cars/loadedreview",
        };
        data = { ...commonData, ...tripScreen };
        pageViewOmniEvent(store, "goCarsTripCategoryScreen")
        break;
      case "goCarsPaymentOptionScreen":
        const paymentsOptions = {
          cdCatQuery: "cabs",
          booking_tags: booking_tags?.join(","),
          other_tags: other_tags?.join(","),
          selected_sku: key,
          source_city,
          destination_city,
          sector: `${source_city} - ${destination_city}`,
          search_tags: search_tags?.join(","),
          return_offset,
          virtualpage: "/cars/payment_option",
        };
        data = { ...commonData, ...paymentsOptions };
        break;
      case "goCarsBookingReviewScreen":
        const reviewScreen = {
          cdCatQuery: "cabs",
          booking_tags: booking_tags?.join(","),
          other_tags: other_tags?.join(","),
          selected_sku: key,
          source_city,
          destination_city,
          sector: `${source_city} - ${destination_city}`,
          search_tags: search_tags?.join(","),
          return_offset,
          sku: sku_event_key,
          virtualpage: "/cars/confirm",
        };
        data = { ...commonData, ...reviewScreen };
        pageViewOmniEvent(store, "goCarsBookingReviewScreen")
        break;
      case gcRouteSEOScreen:
        const routeScreen = {
          cdCatQuery: "cabs",
          flow: "seo",
          sector: seo_meta?.sector,
          virtualpage: seo_meta?.page,
        };
        data = { ...commonData, ...routeScreen };
        pageViewOmniEvent(store, gcRouteSEOScreen)
        break;
      case gcCitySEOScreen:
        const cityScreen = {
          cdCatQuery: "cabs",
          flow: "seo",
          sector: seo_meta?.sector,
          virtualpage: seo_meta?.page,
        };
        data = { ...commonData, ...cityScreen };
        pageViewOmniEvent(store, gcCitySEOScreen)
        break;
        case gcAirportCitySEOScreen :
          const airportCityScreen = {
            cdCatQuery: "cabs",
            flow: "seo",
            sector: seo_meta?.sector,
            virtualpage: seo_meta?.page,
          };
          data = { ...commonData, ...airportCityScreen };
          pageViewOmniEvent(store, gcAirportCitySEOScreen)
          break;
        case "goCarsRentalSEOScreen":
          pageViewOmniEvent(store, "goCarsRentalSEOScreen")
          break;
        case "goCarsCharDhamSEOScreen":
          const charDhamScreen = {
            cdCatQuery: "cabs",
            flow: "seo",
            sector: seo_meta?.sector,
            virtualpage: seo_meta?.page,
          };
          data = { ...commonData, ...charDhamScreen };
          pageViewOmniEvent(store, "goCarsCharDhamSEOScreen")
          break;
      default:
        break;
    }
  };
};
